// extracted by mini-css-extract-plugin
export default {"action":"Action-module__action__FNu-i","content":"Action-module__content__8xkwy","lock":"Action-module__lock__2KbTq"};